require('../../modules/es.object.create');
var path = require('../../internals/path');

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/create.js
// module id = 473
// module chunks = 0 1